export const BOM_USAGE_USED = 'USED';
export const BOM_USAGE_NOT_USED = 'NOT_USED';

export function createEmptyPosition(overrides = {}) {
  return {
    name: '',
    usageType: BOM_USAGE_USED,
    ...overrides,
  };
}

export function createEmptyMaterial(overrides = {}) {
  return {
    mtrId: '',
    mtrNo: '',
    mtrName: '',
    positions: [],
    ...overrides,
  };
}

export function createEmptyGroup(overrides = {}) {
  return {
    name: '',
    materials: [],
    ...overrides,
  };
}

export function countUsedQty(positions = []) {
  return positions.filter((position) => position?.usageType === BOM_USAGE_USED).length;
}

export function mapPickerRowToBomMaterial(row) {
  return createEmptyMaterial({
    mtrId: row?.optionMtrId ?? row?.mtrId ?? '',
    mtrNo: row?.mtrNo ?? '',
    mtrName: row?.name ?? row?.mtrName ?? '',
    positions: [],
  });
}

export function mapDetailGroupsToForm(groups = []) {
  return (groups ?? []).map((group) => {
    const materials = group?.mtrs ?? group?.materials ?? [];
    return {
      name: group?.name ?? '',
      materials: materials.map((material) => {
        const mtr = material?.mtr ?? null;
        return {
          mtrId: material?.mtrId
            ?? material?.sourceMtrId
            ?? mtr?.id
            ?? '',
          mtrNo: mtr?.mtrNo ?? material?.mtrNo ?? '',
          mtrName: mtr?.name ?? material?.mtrName ?? '',
          positions: (material?.positions ?? []).map((position) => ({
            name: position?.name ?? '',
            usageType: position?.usageType === BOM_USAGE_NOT_USED
              ? BOM_USAGE_NOT_USED
              : BOM_USAGE_USED,
          })),
        };
      }),
    };
  });
}

export function collectUsedMtrIds(groups = []) {
  const ids = new Set();
  (groups ?? []).forEach((group) => {
    (group?.materials ?? []).forEach((material) => {
      if (material?.mtrId) {
        ids.add(material.mtrId);
      }
    });
  });
  return ids;
}

export function createEmptyExtraMaterial(overrides = {}) {
  return {
    mtrId: '',
    mtrNo: '',
    mtrName: '',
    qty: 1,
    ...overrides,
  };
}

export function mapPickerRowToExtraMaterial(row) {
  return createEmptyExtraMaterial({
    mtrId: row?.optionMtrId ?? row?.mtrId ?? '',
    mtrNo: row?.mtrNo ?? '',
    mtrName: row?.name ?? row?.mtrName ?? '',
    qty: 1,
  });
}

export function mapDetailExtraMaterialsToForm(extraMaterials = []) {
  return (extraMaterials ?? []).map((item) => {
    const mtr = item?.mtr ?? null;
    return {
      mtrId: item?.mtrId ?? mtr?.id ?? '',
      mtrNo: mtr?.mtrNo ?? item?.mtrNo ?? '',
      mtrName: mtr?.name ?? item?.mtrName ?? '',
      qty: item?.qty ?? 1,
    };
  });
}

/** Detail／list 的 `extraMtrs` 或舊 `extraMaterials` → 表單列。 */
export function mapDetailExtraMtrsToForm(detailOrList = []) {
  if (Array.isArray(detailOrList)) {
    return mapDetailExtraMaterialsToForm(detailOrList);
  }
  return mapDetailExtraMaterialsToForm(getBomExtraMaterials(detailOrList));
}

/** 附加料：API `extraMtrs` 或舊 `extraMaterials`／工單 bomSnapshot `extraMaterials`。 */
export function getBomExtraMaterials(detailOrSnapshot) {
  return detailOrSnapshot?.extraMtrs ?? detailOrSnapshot?.extraMaterials ?? [];
}

/** 群組列：API `mtrs` 或舊 `materials`／工單 bomSnapshot `materials`。 */
export function getBomGroupMaterials(group) {
  return group?.mtrs ?? group?.materials ?? [];
}

/** 複製模式：代號／版本一律加 `-COPY` 後綴 */
export function withBomCopySuffix(value) {
  return `${value ?? ''}-COPY`;
}
